module.exports = __webpack_public_path__ + "img/12.5dcd0ad0.jpg";